<template>
  <div class="d-flex">
    <a
      v-if="showMore"
      class="link mr-2"
      @click="$emit('more')"
    >
      Show more
    </a>
    <a
      v-if="showLess"
      class="link"
      @click="$emit('less')"
    >
      Show less
    </a>
  </div>
</template>
<script>
export default {
  name: 'SmallPagination',
  props: {
    showMore: {
      type: Boolean,
      required: true,
    },
    showLess: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
